import {Component, Input, SimpleChanges} from '@angular/core';
import {Components} from "@gen-nexus-registry/grid-lib";
import {GridLibAngularComponentModule} from '@gen-nexus-registry/grid-lib-angular/dist/grid-lib-angular-component';
import {NgIf} from "@angular/common";
import GridToast = Components.GridToast;

@Component({
  selector: 'app-check-iban-result-card',
  templateUrl: './result-card.component.html',
  standalone: true,
  imports: [
    GridLibAngularComponentModule, NgIf
  ]
})
export class ResultCardComponent {
  @Input() result: any | undefined = undefined;
  message: string | undefined = undefined;
  type: GridToast["type"] | undefined = undefined;


  ngOnChanges(changes: SimpleChanges) {
    const newResult = changes['result'].currentValue

    if (newResult) {
      if (newResult.status === 'NA') {
        this.message = `L'istituto dell'IBAN ${newResult.iban} non aderisce al servizio`
        this.type = "error"
      } else {
        if (newResult.fiscalCode !== undefined) {
          this.message = `L'IBAN ${newResult.iban}${newResult.status === 'KO' ? " non " : " "}corrisponde al Codice Fiscale ${newResult.fiscalCode}`
          this.type = newResult.status === 'KO' ? 'warning' : 'success'
        } else if (newResult.vatCode !== undefined) {
          this.message = `L'IBAN ${newResult.iban}${newResult.status === 'KO' ? " non " : " "}corrisponde alla Partita IVA ${newResult.vatCode}`
          this.type = newResult.status === 'KO' ? 'warning' : 'success'
        }
      }
    }
  }
}
